export type CampaignType = 'Outbound' | 'Inbound';
export type CampaignState = 'Activo' | 'Inactivo' | 'Pausado';
export type LanguageSupports =
  | 'ar'
  | 'bg'
  | 'cs'
  | 'da'
  | 'de'
  | 'el'
  | 'en'
  | 'en-us'
  | 'en-gb'
  | 'es'
  | 'es-419'
  | 'et'
  | 'fi'
  | 'fr'
  | 'he'
  | 'hu'
  | 'id'
  | 'it'
  | 'ja'
  | 'ko'
  | 'lt'
  | 'lv'
  | 'nb'
  | 'nl'
  | 'pl'
  | 'pt'
  | 'pt-br'
  | 'pt-pt'
  | 'ro'
  | 'ru'
  | 'sk'
  | 'sl'
  | 'sv'
  | 'th'
  | 'tr'
  | 'uk'
  | 'vi'
  | 'zh'
  | 'zh-hans'
  | 'zh-hant';

export interface LanguageOption {
  value: LanguageSupports;
  label: string;
}


export const LANGUAGE_OPTIONS: LanguageOption[] = [
  {value: 'en', label: 'English'},
  // { value: 'en-us', label: 'English (US)' },
  // { value: 'en-gb', label: 'English (UK)' },
  {value: 'es', label: 'Español'},
  // { value: 'es-419', label: 'Español (Latinoamérica)' },
  {value: 'fr', label: 'Français'},
  {value: 'de', label: 'Deutsch'},
  {value: 'it', label: 'Italiano'},
  {value: 'pt', label: 'Português'},
  // { value: 'pt-br', label: 'Português (Brasil)' },
  // { value: 'pt-pt', label: 'Português (Portugal)' },
  {value: 'zh', label: '中文'},
  // { value: 'zh-hans', label: '简体中文 (Simplified)' },
  // { value: 'zh-hant', label: '繁體中文 (Traditional)' },
  {value: 'ja', label: '日本語'},
  {value: 'ko', label: '한국어'},
  {value: 'ru', label: 'Русский'},
  {value: 'ar', label: 'العربية'},
  {value: 'tr', label: 'Türkçe'},
  {value: 'pl', label: 'Polski'},
  {value: 'nl', label: 'Nederlands'},
  {value: 'sv', label: 'Svenska'},
  {value: 'fi', label: 'Suomi'},
  {value: 'da', label: 'Dansk'},
  {value: 'nb', label: 'Norsk Bokmål'},
  {value: 'cs', label: 'Čeština'},
  {value: 'sk', label: 'Slovenčina'},
  {value: 'sl', label: 'Slovenščina'},
  {value: 'hu', label: 'Magyar'},
  {value: 'el', label: 'Ελληνικά'},
  {value: 'ro', label: 'Română'},
  {value: 'uk', label: 'Українська'},
  {value: 'bg', label: 'Български'},
  {value: 'et', label: 'Eesti'},
  {value: 'lt', label: 'Lietuvių'},
  {value: 'lv', label: 'Latviešu'},
  {value: 'he', label: 'עברית'},
  {value: 'th', label: 'ไทย'},
  {value: 'vi', label: 'Tiếng Việt'},
  {value: 'id', label: 'Bahasa Indonesia'},
];

export interface TimeSettings {
  hours: number;
  minutes: number;
  seconds: number;
}

export interface PriorityIncrease {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export interface GeneralCampaign {
  accept_conversation: boolean;
  enable_file_upload: boolean;
  enable_file_download: boolean;
  enable_ticket_field: boolean;
}

export interface TranslationConfig {
  enable: boolean;
  source_language?: LanguageSupports | 'es';
  target_language?: LanguageSupports | 'es';
  improve_redaction?: boolean;
}

export interface AutomaticNotificationsQueue {
  id_retrie: number;
  message: string;
  time: number;
}

export interface ConversationConfig {
  allow_automatic_message: boolean;
  how_often_message: number;
  automatic_message_value: string;
  retries: number;
  automatic_notifications_queue: AutomaticNotificationsQueue[];
}

export interface TimeSettingsConfig {
  enable: boolean;
  days: string[];
  start_time: TimeSettings;
  end_time: TimeSettings;
}


export interface AgentCampaign {
  agent_id: string;
  priority: number;
}


export interface AgentConfig {
  enable: boolean;
  transfer_between_agent: boolean;
  enable_priority_agent: boolean;
  order_priority_agent: AgentCampaign[]
}

export interface QuestionAnswerItem {
  question: string;
  answer: string;
}

export interface DefaultQuestionAnswerConfig {
  enable: boolean;
  questions_answers?: QuestionAnswerItem[];
}

export interface DefaultMessagesConfig {
  enable: boolean;
  messages: string[];
}

export interface Campaign {
  id: string | null;
  name: string;
  campaign_name: string;
  type: CampaignType;
  state: CampaignState;
  priority: number;
  ratio: string;
  current_action: string;
  closing_reason: string[];
  state_since: Date | string;  // Allow string for raw API values
  created_at: Date | string;
  updated_at: Date | string;

  general_config?: GeneralCampaign;
  translation_config?: TranslationConfig;
  conversation_config?: ConversationConfig;
  time_settings_config?: TimeSettingsConfig;
  agent_config?: AgentConfig;
  default_messages_config?: DefaultMessagesConfig;
  default_questions_answers_config?: DefaultQuestionAnswerConfig;

  workspace_id?: string;
  platform_id?: number;
}

export interface CampaignRequestList {
  ids?: string[];
}

export interface CampaignRequestWorkspace {
  workspace_id?: string;
}

export interface CampaignInDB extends Campaign {
  // Inherits all Campaign properties
}

